<template>
	<div class="pv" v-if="tariffType !== undefined">
		<div class="pv__elm">
			<!-- ///////////// -->
			<!-- BACKWARD LINK -->
			<div class="pv__elm-backward">
				<div
					v-if="!device.isMobile"
					class="pv__elm-backward-link"
					@click="onClickRedirect('instances')"
				>
					<IconArrowLeft color="rgb(49, 49, 50)" />
				</div>
				<div class="pv__elm-backward-label">Оплата</div>
			</div>

			<!-- //////////////// -->
			<!-- PAYMENT -->
			<FormPayment v-on:is-balance="onIsBalance" />

			<!-- //////////////// -->
			<!-- История транзакций -->
			<div v-if="isPayHistory" class="pv__elm-transaction-label">
				История транзакций
			</div>
			<PaymentHistory class="pv__elm-transaction-history" />
		</div>
		<div v-show="false">
			{{ tariffType }}
		</div>
	</div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import { mapGetters } from "vuex";
import IconArrowLeft from "@/components/icons/IconArrowLeft.vue";
import FormPayment from "@/components/payment/FormPayment.vue";
import PaymentHistory from "@/components/payment/PaymentHistory.vue";
import { IPaymentChannelDetail } from "@/interfaces/IPaymentChannelDetail";

@Options({
	components: {
		PaymentHistory,
		FormPayment,
		IconArrowLeft,
	},
	computed: {
		...mapGetters("instanceModule", {
			device: "getDevice",
		}),
		...mapGetters("paymentModule", {
			payHistory: "payHistoryGetters",
			payChannelDetail: "payChannelDetailGetters",
		}),
	},
})
export default class PaymentView extends Vue {
	public isBalance = true;
	// Const declaration
	public readonly TARIFF = { FREE: 1 };

	// ************************************************************
	// Define mapGetters
	public device: { isMobile: boolean };
	public payHistory: Array<{
		type: number;
		amount: number;
		paidStamp: number;
	}>;
	public payChannelDetail: IPaymentChannelDetail;

	/**
	 * Tariff type
	 */
	public get tariffType() {
		if (this.payChannelDetail.tariff?.type === this.TARIFF.FREE) {
			return this.$router.back();
		}
		return this.payChannelDetail.tariff?.type;
	}

	/**
	 * Переход на другую страницу
	 * @param routeName
	 * @param id
	 */
	public onClickRedirect(routeName: string, id?: number) {
		this.$router.push({ name: routeName, params: { id: id } });
	}

	/**
	 * true - balance
	 * false - channels
	 * @param value
	 */
	public onIsBalance(value: boolean) {
		this.isBalance = value;
	}

	/**
	 * Computed
	 * TRUE - если есть история
	 * FALSE - если нет истории
	 */
	public get isPayHistory() {
		return this.payHistory.length !== 0;
	}
}
</script>

<style scoped lang="scss">
.pv {
	display: flex;
	justify-content: center;
	user-select: none;

	&__elm {
		display: flex;
		flex-direction: column;
		flex-grow: 1;
		max-width: 649px;
	}

	&__elm-backward {
		display: flex;
		padding: 24px 0;
	}

	&__elm-backward-link {
		cursor: pointer;
	}

	&__elm-backward-label {
		padding-left: 12px;
		color: rgb(49, 49, 50);
		font-size: 24px;
		font-weight: 600;
	}

	&__elm-transaction-label {
		padding: 24px 0 8px;
		font-size: 18px;
		font-weight: 600;
		color: rgb(49, 49, 50);
	}

	&__elm-transaction-history {
		padding-bottom: 12px;
	}

	@media screen and (max-width: 768px) {
		&__elm {
			display: flex;
			flex-direction: column;
			flex-grow: 1;
			padding: 0 12px;
			min-width: 100px;
		}

		&__elm-backward {
			padding: 16px 0;
		}

		&__elm-backward-label {
			padding-left: 0;
			font-size: 18px;
		}

		&__elm-transaction-label {
			padding: 16px 0 8px;
			font-size: 16px;
			font-weight: 600;
		}
	}
}
</style>
